<div fxFlex="100" class="inputs" fxLayout="row wrap">
    <!-- First Name -->
    <app-text-field [isEditable]="isEditable" [label]="'First Name*'" [(ngModel)]="userObject.first_name"
        [name]="'first_name'" [errors]="errorObj.first_name" fxFlex="12em" fxFlex.xs="10em" fxLayout="column">
    </app-text-field>

    <!-- Last Name -->
    <app-text-field [isEditable]="isEditable" [label]="'Last Name*'" [(ngModel)]="userObject.last_name"
        [name]="'last_name'" [errors]="errorObj.last_name"  fxFlex="12em" fxFlex.xs="10em" fxLayout="column">
    </app-text-field>

    <!-- Email ID -->
    <app-text-field [isEditable]="isEditable && !userObject.id" [label]="'Email ID*'" [(ngModel)]="userObject.email"
        [name]="'email'" [errors]="errorObj.email" class="word-wrap"  fxFlex="12em" fxFlex.xs="10em" fxLayout="column">
    </app-text-field>

    <!-- Mobile Number -->
    <app-phone-field [isEditable]="isEditable" [label]="'Mobile No'" [(ngModel)]="userObject.mobile_number"
        [name]="'mobile_number'" (countryEmitter)="getRegionByIsdCode($event)" [errors]="errorObj.mobile_number"
        [removeCross]="true"  fxFlex="12em" fxFlex.xs="10em" fxLayout="column">
    </app-phone-field>

    <!-- Designation -->
    <app-text-field [isEditable]="isEditable" [label]="'Designation'" [(ngModel)]="userObject.designation"
        [name]="'email'" [errors]="errorObj.designation" class="m1em"  fxFlex="12em" fxFlex.xs="10em" fxLayout="column">
    </app-text-field>

    <!-- Department -->
    <app-mat-auto-search [isEditable]="isEditable" [label]="'Department Name*'" [(ngModel)]="userObject.department"
        [name]="'department'"  fxFlex="12em" fxFlex.xs="10em" fxLayout="column" [listUrl]="department_url+'?name=::search::'"
        [displayField]="'name'" [idField]="null" [errors]="errorObj.department">
    </app-mat-auto-search>

    <!-- Role -->
    <app-mat-auto-search  [isEditable]="isEditable && !userObject.id" [label]="'Role Name*'"
        [(ngModel)]="userObject.role" class="m1em"  fxFlex="12em" fxFlex.xs="10em" fxLayout="column" [name]="'role'"
        [displayField]="'name'" [listUrl]="role_url" [idField]="null" [errors]="errorObj.role">
    </app-mat-auto-search>

    <!-- Manager -->
    <app-mat-auto-search [isEditable]="isEditable" [label]="'Manager Name'" [(ngModel)]="userObject.manager"
        [name]="'manager'" [listUrl]="user_url+'?search=::search::&is_internal=1'" [displayField]="'first_name'"
        [idField]="null" class="ai-fxs m1em "  fxFlex="12em" fxFlex.xs="10em" fxLayout="column" [labelItemTemplate]="managerSelectedItem"
        [itemTemplate]="managerItem" [displayTemplate]="managerDisplayItem" [errors]="errorObj.manager">
    </app-mat-auto-search>

    <!-- Region -->
    <app-mat-auto-search [isEditable]="isEditable" [label]="'Region*'" [(ngModel)]="userObject.region" [name]="'region'"
        [listUrl]="region_url+'?name=::search::'" [displayField]="'name'" [idField]="null" class="m1em" 
        fxFlex="12em" fxFlex.xs="10em" fxLayout="column" [errors]="errorObj.region">
    </app-mat-auto-search>

    <div fxFlex="12em" fxLayout="column "></div>
    <!-- </div> -->
    <div class="m1em countriesInput"  fxLayout="row wrap" fxFlex="100">
        <div fxFlex="100" class="inputTitle">
            <span>Profile Avatar</span>
        </div>
        <div class="spacearound" fxFlex="100" fxLayout="row wrap" *ngIf="userObject.picture==null">
            <div  class="iconBox">
                <div class="icon" [class.selected]="userObject.gender =='Female'">
                    <img src="/assets/images/users/woman.svg" (click)="userObject.gender='Female'">
                </div>
            </div>
            <div  class="iconBox">
                <div class="icon" [class.selected]="userObject.gender=='Male'">
                    <img src="/assets/images/users/man.svg" (click)="userObject.gender='Male'">
                </div>
            </div>
        </div>
        <div class="spacearound" fxFlex="100" fxLayout="row wrap" *ngIf="userObject.picture!=null">
            <div class="iconBox profile">
                <div class="icon">
                    <img [src]="userObject.picture.document_file">
                </div>
            </div>
        </div>
    </div>
    <div class="ai-fxs m1em checker" fxFlex="26.4em" fxFlex.xs="18.4em" fxLayout="column">
        <section>
            <mat-checkbox color="primary" [(ngModel)]="userObject.is_active" checked [disabled]="!isEditable">Active
            </mat-checkbox>
        </section>
    </div>
    <div class="btnb">
        <button mat-stroked-button class="nxt" (click)="onUserSave()">{{isEditable?'Save':'Edit'}}</button>
    </div>
</div>

<!-- Manager template for dropdown -->
<ng-template #managerItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{item?.first_name}} {{item?.last_name}}
        </span>
        <span class="email">
            {{item?.email}}
        </span>
    </div>
</ng-template>

<ng-template #managerSelectedItem let-item>
    {{item?.first_name}} {{item?.last_name}}
</ng-template>

<ng-template #managerDisplayItem let-item>
    {{item?.first_name}} {{item?.last_name}}
</ng-template>